import styled from 'styled-components'
import { DARK_VIOLET, GRAYSCALE_300, GRAYSCALE_400, GRAYSCALE_500, NEUTRAL_100, WHITE } from '@styles/colors'
import { INTER } from '@styles/fonts'

export const Container = styled.div<{ $hasSelectedOption: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px 12px 12px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px ${({ $hasSelectedOption }) => $hasSelectedOption ? 'solid' : 'dashed'} ${({ $hasSelectedOption }) => $hasSelectedOption ? NEUTRAL_100 : GRAYSCALE_400};
`

export const EmptySelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

export const PlusIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px dashed ${GRAYSCALE_400};
  font-size: 13px;
`

export const SelectText = styled.span`
  font-family: ${INTER.medium};
  font-size: 13px;
  color: ${DARK_VIOLET};
`

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  width: 100%;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${WHITE};
  border-radius: 12px;
  color: black;
  max-height: 80vh;
`

export const SearchContainer = styled.div`
  padding: 12px;
  border-bottom: 1px solid ${GRAYSCALE_300};
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 8px;
  overflow-y: auto;
  max-height: 400px;
  margin: 6px 0;
`

export const OptionItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  position: relative;
`

export const TrashIconWrapper = styled.div<{ $lastItem: boolean }>`
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-${({ $lastItem }) => $lastItem ? '50' : '60'}%);
  cursor: pointer;
  z-index: 10;
`

export const OptionDivider = styled.div`
  display: flex;
  flex-direction: column;
  height: 1px;
  width: 100%;
  background-color: ${NEUTRAL_100};
`

export const NoResultsText = styled.div`
  padding: 16px 0;
  text-align: center;
  color: ${GRAYSCALE_500};
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 8px;
  border-top: 1px solid ${GRAYSCALE_300};
`
